import script from "./BaseFlipper.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseFlipper.vue?vue&type=script&setup=true&lang=ts"

import "./BaseFlipper.vue?vue&type=style&index=0&id=67e3c676&lang=scss"

const __exports__ = script;

export default __exports__